import {
  Project,
  ProjectFileUpload,
  ProjectVirtualGraph,
} from 'src/store/state/projects';
import { replaceInvalidIriChars } from 'src/utils/removeInvalidIriChars';
import { replaceInvalidNameChars } from 'src/utils/removeInvalidNameChars';

export const getDefaultProjectPrefix = (project: Project) =>
  `tag:stardog:designer:${replaceInvalidIriChars(project.name)}:`;

export const getDefaultProjectModelPrefix = (project: Project) =>
  `${getDefaultProjectPrefix(project)}model:`;

export const getDefaultProjectDataPrefix = (project: Project) =>
  `${getDefaultProjectPrefix(project)}data:`;

export const generateModelNamedGraph = (project: Project) =>
  project.modelNamespace.slice(0, -1);

export const generateModelConceptIri = (project: Project, label = '') =>
  `${project.modelNamespace}${replaceInvalidIriChars(label)}`;

export const generateFileUploadNamedGraph = (
  project: Project,
  fileUpload: ProjectFileUpload
) => `${project.dataNamespace}${replaceInvalidIriChars(fileUpload.name)}`;

export const generateVirtualGraphPrefix = (project: Project) =>
  `${replaceInvalidNameChars(project.name)}__data__`;

export const generateVirtualGraphName = (
  project: Project,
  virtualGraph: ProjectVirtualGraph
) =>
  `${generateVirtualGraphPrefix(project)}${replaceInvalidNameChars(
    virtualGraph.dataSourceId
  )}`;
